import Castilo71 from './Castilo 7.webp'
import Castilo72 from './Castilo 7.webp'





const Castilo7images =[
Castilo71,Castilo72
]

export default Castilo7images;